import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { url } from '../config/site';
import { getUpcomingEvents } from '../actions/events';

const EventBar = props => {
	useEffect(() => {
		if(!props.events || !props.events.length) {
			props.getUpcomingEvents();
		}
	}, []);

	if(!props.events || !props.events.length) return null;
	
	let activeEvent = props.events && props.events.length ? props.events[0] : null;
	if(props.events && props.events.length) {
		activeEvent = props.events.find(({ id }) => id === '110274044636') || activeEvent;
	}

	return(
		<div className="event-bar">
			<div className="cta-strip">
				<div className="cta-strip__inner">
					<p>Register for our 8-Week Startup Club Programme</p>
					<a
						className="slant-btn"
						href={'https://www.eventbrite.co.uk/e/startup-club-8-week-programme-tickets-110274044636?aff=odeimcmailchimp&mc_cid=d59583d816&mc_eid=6b37e032b7'}
						target="_blank"
					>Register now</a>
				</div>
			</div>

			<div className="container">
				<div className="row">
					<div className="col-xs-12">
						<div className="card" style={{ backgroundImage: `url(${activeEvent.logo.url})` }}>
							<p className="card__title">Next</p>
							<div className="card__overlay">
								<p>{ activeEvent.name.text }</p>
								<i className="icon icon-arrow-right" />
							</div>

							<a href={activeEvent.url} target="_blank">
								<span className="sr-only">{ activeEvent.name.text }</span>
							</a>
						</div>

						<div className="card">
							<p className="card__title">Be the first to find out about upcoming sessions</p>
							<Link to={'/sign-up'} className="card__btn">Subscribe for updates</Link>
						</div>

						<div className="card schedule-card">
							<p className="card__title">Coming up</p>
							<ul>
								{ props.events.map(ev => (
									<li key={ev.id}>
										<p>({ moment(ev.start.utc).utc().format('DD/M') }) { ev.name.text }</p>
										<a 
											href={ev.url} 
											className="slant-btn"
											target="_blank"
										>Book now</a>
									</li>
								)) }
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const mapStateToProps = state => ({
	events: state.events.all,
	fetching: state.events.fetching.all,
});

const mapDispatchToProps = dispatch => bindActionCreators({
	getUpcomingEvents
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EventBar);


// WEBPACK FOOTER //
// ./src/js/components/EventBar.jsx